var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUrineLossPadTest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 31,
    viewBox: "0 0 24 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1507 3.02366L12.0002 2.7959L11.8497 3.02305C11.5642 3.45587 4.84766 13.6875 4.84766 20.014C4.84766 24.8573 8.05616 28.7962 12.0002 28.7962C15.9437 28.7962 19.1527 24.8573 19.1527 20.014C19.1527 13.6875 12.4357 3.45587 12.1507 3.02366ZM12.0002 26.8642C8.92366 26.8642 6.42166 23.7921 6.42166 20.014C6.42166 16.4889 9.27466 10.4902 12.0002 5.9527C14.7257 10.4871 17.5782 16.4833 17.5782 20.014C17.5782 23.7921 15.0752 26.8642 12.0002 26.8642Z",
    fill: "#009FD9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9343 23.4062C11.9023 23.4062 10.9293 22.912 10.1968 22.0151C9.46576 21.1157 9.06326 19.9228 9.06326 18.6532C9.06326 18.1203 8.71026 17.6875 8.27626 17.6875C7.84276 17.6875 7.48926 18.1203 7.48926 18.6532C7.48976 22.3392 9.93226 25.3388 12.9343 25.3388C13.3678 25.3388 13.7213 24.906 13.7213 24.3725C13.7213 23.8402 13.3678 23.4062 12.9343 23.4062Z",
    fill: "#009FD9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUrineLossPadTest);
export default __webpack_public_path__ + "static/media/UrineLossPadTest.be782c7f693cee078f67799ff6e28d1d.svg";
export { ForwardRef as ReactComponent };